import { cloudFunctionsAxios, getCloudRunServiceUrl } from './axios';

interface CityCreationData {
  name: string;
  state: string;
  stateFull: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  marketData: {
    medianPrice: number;
    averageDaysOnMarket: number;
    propertyCount: number;
  };
}


export const createCity = async (data: Omit<CityCreationData, 'marketData'>) => {
  try {
    const cityData = {
      ...data,
      marketData: {
        medianPrice: 0,
        averageDaysOnMarket: 0,
        propertyCount: 5000,
      },
    };
    const response = await cloudFunctionsAxios.post('/city-creation', cityData);
    return response.data;
  } catch (error) {
    console.error('Error creating city:', error);
    throw error;
  }
};

export const generateLandingPages = async (cityId: string) => {
  try {
    const response = await cloudFunctionsAxios.post('/city-landing-page-generator', {
      city_id: cityId,
    });
    return response.data;
  } catch (error) {
    console.error('Error generating landing pages:', error);
    throw error;
  }
};

export const enableSitemap = async (cityId: string) => {
  try {
    const response = await cloudFunctionsAxios.post('/city-sitemap', {
      city_id: cityId,
      enable: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error enabling sitemap:', error);
    throw error;
  }
};

export const subscribeToCity = async (cityId: string, tenantId: string) => {
  try {
    const response = await cloudFunctionsAxios.post('/city-subscription', {
      tenant_id: tenantId,
      city_ids: [cityId],
    });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to city:', error);
    throw error;
  }
};

export const verifySetup = async (cityId: string) => {
  try {
    const response = await cloudFunctionsAxios.get(`/city-verify-setup/${cityId}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying city setup:', error);
    throw error;
  }
};

export const subscribeToMLS = async (tenantId: string, mlsIds: string[]) => {
  try {
    const response = await cloudFunctionsAxios.post(
      getCloudRunServiceUrl('mls-subscription'),
      {
        tenant_id: tenantId,
        mls_id: mlsIds,
      }
    );
    return response;
  } catch (error) {
    console.error('Error updating MLS subscriptions:', error);
    throw error;
  }
};

export const generateCitySitemap = async (tenantId: string) => {
  try {
    const response = await cloudFunctionsAxios.post(
      getCloudRunServiceUrl('city-sitemap-generator'),
      { tenantId }
    );
    return response;
  } catch (error) {
    console.error('Error generating city sitemap:', error);
    throw error;
  }
};
